import {HeaderService} from '../../../../../services/header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment.prod';
import {TvaSummary} from '../../../../../models/TvaSummary';

@Component({
  selector: 'app-approve-cmd-negoce',
  templateUrl: './approve-cmd-negoce.component.html',
  styleUrls: ['./approve-cmd-negoce.component.scss']
})
export class ApproveCmdNegoceComponent implements OnInit {

    mode: 'validation' | 'apercu' = 'validation';

    file: string = environment.file_url;
    constructor(private headerService: HeaderService, private router : Router, private route: ActivatedRoute) { }
    tvaSummary: TvaSummary[] = [];
    totals = {
        totalHT: 0,
        totalTVA: 0,
        totalTTC: 0,
        timbreFiscal: 0.6,
        netAPayer: 0.6
    };
    ngOnInit(): void {
        this.mode = this.route.snapshot.paramMap.get('mode') as 'validation' | 'apercu';
        this.setHeaderConfig();

    }
    setHeaderConfig(): void {
        if (this.mode === 'validation') {
            this.headerService.setConfig({
                title: 'Commandes Clients',
                buttons: [
                    { label: 'Retour', action: () => this.retour(), type: 'primary' },
                    { label: 'Annuler', action: () => this.retour(), type: 'secondary' }

                ]
            });
        } else {
            this.headerService.setConfig({
                title: ' Commande Client',
                buttons: [
                    { label: 'Mettre à jour', action: () => this.editagain(), type: 'primary' }
                ]
            });
        }
    }
    exportData() {
        console.log('Exporting data...');
    }

    retour() {
        this.router.navigate(['/vente-negoce/commande-client']);
    }
    editagain(){
        this.router.navigate(['/vente-negoce/commande-client/add-commande-client']);
    }

}
